<script>
export default {
  props: ['user', 'userIndex', 'isLast', 'isFirst', 'groups', 'roleOptions'],
  data () {
    return {
      isEmailValid: true,
      hasRequiredEmail: true
    }
  },
  computed: {
    isFormValid () {
      return this.isEmailValid && this.hasRequiredEmail
    },
    validationFeedback () {
      if (!this.isEmailValid) {
        return 'Veuillez saisir une adresse email valide'
      }
      if (!this.hasRequiredEmail) {
        return 'Veuillez renseigner une adresse email'
      }
      return ''
    },
    formattedGroups () {
      return (this.groups || []).map(group => ({
        value: group.uuid,
        text: group.label
      }))
    },
    roleOptionsMap () {
      return (this.roleOptions || []).reduce((options, role) => {
        options[role.value] = role.label
        return options
      }, {})
    }
  },
  mounted () {
    this.validateIdentifiers()
  },
  methods: {
    onFieldInput (label, value) {
      this.$emit('update', { label, value })
      this.$nextTick(() => {
        this.validateIdentifiers()
      })
    },
    validateIdentifiers () {
      const email = (this.user.email || '').trim()
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

      this.isEmailValid = email === '' ? true : emailRegex.test(email)
      this.hasRequiredEmail = email !== ''

      this.$emit('error', !this.isFormValid)
    }
  }
}
</script>

<template>
  <section v-if="user" class="user-create-form grid grid-cols-4 gap-5 auto-rows-min">
    <header v-if="!(isLast && isFirst)" class="user-create-form__header col-span-4">
      <span>Utilisateur {{ userIndex + 1 }}</span>
      <button
        v-if="!isFirst"
        type="button"
        aria-label="Retirer cet utilisateur"
        @click="$emit('removeUser')"
      >
        <i class="fas fa-trash-alt" />
      </button>
    </header>

    <t-input-group label="Rôle" class="col-span-4">
      <t-select
        :value="user.role"
        :options="roleOptionsMap"
        @input="$event => onFieldInput('role', $event)"
      />
    </t-input-group>

    <div class="col-span-4">
      <t-input-group
        label="Email"
        :variant="{ 'danger': !isFormValid }"
        :feedback="validationFeedback"
      >
        <t-input
          type="email"
          :variant="{ 'danger': !isFormValid }"
          :value="user.email"
          @input="$event => onFieldInput('email', $event)"
          @blur="validateIdentifiers"
        />
      </t-input-group>
    </div>

    <t-input-group
      label="Matricule"
      class="col-span-4"
    >
      <t-input
        type="text"
        :value="user.internal_id_number"
        @input="$event => onFieldInput('internal_id_number', $event)"
        @blur="validateIdentifiers"
      />
    </t-input-group>

    <t-input-group
      label="Nom"
      class="col-span-4 md:col-span-2"
    >
      <t-input
        type="text"
        :value="user.lastname"
        @input="$event => onFieldInput('lastname', $event)"
      />
    </t-input-group>

    <t-input-group
      label="Prénom"
      class="col-span-4 md:col-span-2"
    >
      <t-input
        type="text"
        :value="user.firstname"
        @input="$event => onFieldInput('firstname', $event)"
      />
    </t-input-group>

    <t-input-group
      label="Groupes (facultatif)"
      v-if="formattedGroups.length > 0"
      class="col-span-4 md:col-span-4"
    >
      <t-rich-select
        multiple
        :close-on-select="false"
        :options="formattedGroups"
        placeholder="Sélectionner des groupes"
        v-model="user.groupsSelected"
        value-attribute="value"
        text-attribute="text"
      ></t-rich-select>
    </t-input-group>

    <button
      v-if="isLast"
      type="button"
      class="user-create-form__add col-span-4"
      @click="$emit('addUser')"
    >
      <i class="fas fa-plus" />
      Ajouter un autre utilisateur
    </button>
  </section>
</template>

<style scoped>
.user-create-form + .user-create-form {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

.user-create-form__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #111827;
  font-size: 1rem;
  font-weight: 700;
}

.user-create-form__header button {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #fee2e2;
  color: #b91c1c;
}

.user-create-form__header button:hover {
  background: #fecaca;
}

.user-create-form__add {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border: 1px solid #93c5fd;
  border-radius: 10px;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 0.875rem;
  font-weight: 700;
}

.user-create-form__add:hover {
  border-color: #2563eb;
  background: #dbeafe;
}

.user-create-form__header button:focus-visible,
.user-create-form__add:focus-visible {
  outline: 2px solid #2563eb;
  outline-offset: 2px;
}
</style>
